// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q8Bxc","left":"styles_left__o4KZj"};